<h2 mat-dialog-title>{{type}} Quick Links</h2>
<mat-dialog-content class="container">
  <div *ngIf="shared.length === 0;else shared_list" class="ddl-label">
    No Shared {{typePlural}}
  </div>
  <ng-template #shared_list>
    <table>
      <tr class="header">
        <th class="header-text">Shared</th>
      </tr>
      <tbody>
        <tr class="child" *ngFor="let link of shared; let itemIndex = index;">
          <ng-container *ngIf="link.lifeCycle === 0">
            <td class="child-text">
              <mat-form-field appearance="outline" class="show-no-errors">
                <input matInput [(ngModel)]="link.title" [(value)]="link.title" [readonly]="isReadOnly(link) || link.lifeCycle === 1" [style.text-decoration]="link.lifeCycle === 1 ? 'line-through' : ''" />
              </mat-form-field>
            </td>
            <td>
              <button mat-icon-button [disabled]="isReadOnly(link) || link.lifeCycle === 1" [matMenuTriggerFor]="action_menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #action_menu>
                <button mat-menu-item (click)="link.isShared = false; link.isPinned = false; onClick(link, itemIndex, 'Shared');">Unshare</button>
                <button mat-menu-item (click)="link.isShared = false; onClick(link, itemIndex, 'Shared');">Pin</button>
                <button mat-menu-item (click)="link.lifeCycle = 1">Delete</button>
              </mat-menu>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </ng-template>
  <div *ngIf="pinned.length === 0;else pinned_list" class="ddl-label">
    No Pinned {{typePlural}}
  </div>
  <ng-template #pinned_list>
    <table>
      <tr class="header">
        <th class="header-text">Pinned</th>
      </tr>
      <tbody>
        <tr class="child" *ngFor="let link of pinned; let itemIndex = index;">
          <ng-container *ngIf="link.lifeCycle === 0">
            <td class="child-text">
              <mat-form-field appearance="outline" class="show-no-errors">
                <input matInput [(ngModel)]="link.title" [(value)]="link.title" [disabled]="link.lifeCycle === 1" [style.text-decoration]="link.lifeCycle === 1 ? 'line-through' : ''" />
              </mat-form-field>
            </td>
            <td>
              <button mat-icon-button [disabled]="isReadOnly(link) || link.lifeCycle === 1" [matMenuTriggerFor]="action_menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #action_menu>
                <button mat-menu-item (click)="link.isShared = true; link.isPinned = true; onClick(link, itemIndex, 'Pinned');">Share</button>
                <button mat-menu-item (click)="link.isShared = false; link.isPinned = false; onClick(link, itemIndex, 'Pinned')">Unpin</button>
                <button mat-menu-item (click)="link.lifeCycle = 1">Delete</button>
              </mat-menu>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </ng-template>
  <table>
    <tr class="header">
      <th class="header-text">Recent</th>
    </tr>
    <tbody>
      <tr class="child" *ngFor="let link of recent; let itemIndex = index;">
        <ng-container *ngIf="link.lifeCycle === 0">
          <td class="child-text">
            <mat-form-field appearance="outline" class="show-no-errors">
              <input matInput [(ngModel)]="link.title" [(value)]="link.title" [disabled]="link.lifeCycle === 1" [style.text-decoration]="link.lifeCycle === 1 ? 'line-through' : ''" />
            </mat-form-field>
          </td>
          <td>
            <button mat-icon-button [disabled]="isReadOnly(link) || link.lifeCycle === 1" [matMenuTriggerFor]="action_menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #action_menu>
              <button mat-menu-item (click)="link.isShared = true; link.isPinned = true; onClick(link, itemIndex, 'Recent')">Share</button>
              <button mat-menu-item (click)="link.isShared = false; link.isPinned = true; onClick(link, itemIndex, 'Recent')">Pin</button>
              <button mat-menu-item (click)="link.lifeCycle = 1">Delete</button>
            </mat-menu>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" (click)="ok()">OK</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
